import { FC } from 'react';

import { IntlProvider } from 'react-intl';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { AuthClientEvent } from '@react-keycloak/core/lib/types';
import {ThemeProvider} from 'styled-components';

import { Routes } from 'Routes';
import { AutorizacaoProvider } from 'view/component/Autorizacao/AutorizacaoProvider';
import { MenuProvider } from 'view/section/Menu/Menu';
import { TemaClaro } from 'styles/theme/TemaClaro';
import { EstiloGlobal } from 'styles/EstiloGlobal';
import { KeycloakService } from 'service/KeycloakService';

import { Provider as ReduxProvider } from 'react-redux';
import { store } from 'store/store';
import { IdTokenParsed } from 'view/component/UsuarioLogadoContext/UsuarioLogadoContext';


const App: FC = () => {
  const keycloak = KeycloakService.instance.keycloak;

  const autenticarQuandoNaoLogado = (eventType: AuthClientEvent) => {
    const idTokenParsed = keycloak.idTokenParsed as IdTokenParsed|undefined;
    if (eventType === "onReady" && idTokenParsed?.id_institucional === undefined) {
      keycloak.login(KeycloakService.LOGIN_OPTIONS);
    }
  }

  return (
    <>
      <EstiloGlobal />
      {/* Parâmetros do initOptions são necessários para evitar o problema
      de reload infinito no Chrome: https://github.com/dasniko/keycloak-reactjs-demo/issues/3#issuecomment-438745122 */}
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={{checkLoginIframe: false}}
        onEvent={autenticarQuandoNaoLogado}
      >
      <ReduxProvider store={store}>
      <AutorizacaoProvider>
      
      <IntlProvider locale="pt-BR">
      <ThemeProvider theme={TemaClaro}>
      <MenuProvider>
        <Routes />
      </MenuProvider>
      </ThemeProvider>
      </IntlProvider>

      
      </AutorizacaoProvider>
      </ReduxProvider>
      </ReactKeycloakProvider>
    </>
  );
}

export default App;
